'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var GridSystem_module = require('./GridSystem.module.scss.js');
var GridSystemCtx = require('./GridSystemCtx.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var GridSystemAlignedElement = react.forwardRef(function (_a, ref) {
    var className = _a.className, style = _a.style, children = _a.children, otherProps = tslib.__rest(_a, ["className", "style", "children"]);
    var colIndex = react.useContext(GridSystemCtx.default).colIndex;
    return (jsxRuntime.jsx("div", tslib.__assign({ style: tslib.__assign(tslib.__assign({}, style), { gridColumn: colIndex + 1 }), className: cx__default.default(GridSystem_module.default['grid__aligned-element'], className), "data-testid": "grid-aligned-element" }, otherProps, { ref: ref }, { children: children })));
});
GridSystemAlignedElement.displayName = 'GridSystemItem.Element';
var GridSystemAlignedElement$1 = GridSystemAlignedElement;

exports.default = GridSystemAlignedElement$1;
//# sourceMappingURL=GridSystemAlignedElement.js.map
